export default "__VITE_ASSET__CiAgeDXr__"